// Vendor imports
const React = require('react')
// Client V2 common imports
const DownloadButton = require('client-v2/into-landing/containers/download-button/component-smart')

/**
 * This is a constant so that it does not change between renders
 * @type {[]}
 * @readonly
 */

function IntoLandingUserListModal(props) {
  const { caption, users, isModalVisible, handleSMSModal, onDismiss } = props

  const handleDownloadClick = React.useCallback(
    () => {
      onDismiss()
      handleSMSModal()
    },
    [ handleSMSModal, onDismiss ]
  )

  if (!isModalVisible) {
    return null
  }
  if (!users || users.size <= 0 ) {
    return null
  }
  return (
    <div className="fixed z-50 top-0 left-0 w-screen h-screen grid place-items-center">
      <button className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 backdrop-blur-sm" onClick={onDismiss}></button>
      <div className="fixed bottom-0 left-0 w-full max-h-[80vh] flex flex-col lg:relative lg:w-[400px] lg:max-w-[90vw] lg:max-h-[80vh] lg:h-auto bg-white text-black rounded-t-xl lg:rounded-xl overflow-auto scrollbar-secondary overflow-hidden">
        <button className="btn absolute top-0 right-0 mt-2 text-sm" onClick={onDismiss}>Close</button>
        <div className="p-4 lg:p-6 overflow-auto flex-1">
          <p className="font-medium text-xl mb-6">{caption}</p>
          <div className="flex-1 space-y-4">
            {users.slice(0, 5).map((user, index) =>
              <div key={user.username} className={`opacity-${100 - (index * 20)}`}>
                <a href={`/${user.username}`} className="flex items-center space-x-4">
                  <img className="shrink-0 inline-block aspect-square object-cover rounded-full w-14" src={user['photo_url']} alt={user['display_name']} />
                  <div className="flex-1 flex flex-col">
                    <p className="font-medium">{user['display_name']}</p>
                    <p className="text-sm truncate opacity-50 mb-1">{`@${user.username}`}</p>
                  </div>
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="bg-stone-300 text-center p-4 lg:p-6 shrink-0">
          <p className="text-sm mb-3 font-medium opacity-75">Sign up to see all content</p>
          <DownloadButton className="btn btn-primary btn-dot" buttonText="Get the App" onClick={handleDownloadClick} />
        </div>
      </div>
    </div>
  )
}

if (__DEV__) {
  // Prop-checking imports
  const Immutable = require('immutable')
  const PropTypes = require('prop-types')
  IntoLandingUserListModal.propTypes = {
    caption: PropTypes.string,
    users: PropTypes.instanceOf(Immutable.Iterable).isRequired,
    isModalVisible: PropTypes.bool,
    handleSMSModal: PropTypes.func,
    onDismiss: PropTypes.func
  }
}

module.exports = IntoLandingUserListModal
